import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-second-opinion-fr',
    templateUrl: './second-opinion-fr.component.html',
    styleUrls: ['./second-opinion-fr.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SecondOpinionFrComponent {
  readonly secondOpinionUrl = 'https://deuxiemeavis.fr/gustaveroussy';
  //readonly internationalSecondOpinionUrlAskPage = 'https://www.gustaveroussy.fr/en/ask-second-opinion';
  readonly internationalSecondOpinionUrl = 'https://secondopinion.gustaveroussy.fr';
}
